import { TwoTimeCashIncentiveKey, TwoTimeCashIncentiveTierData } from '@models/TwoTimeCashIncentive'
import { Store } from '@stores/Store'

export class TwoTimeCashIncentiveCalculation {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  // Two Time Cash Incentive

  get twoTimeCashIncentiveAmount(): number {
    const { store } = this
    const { countryData, twoTimeCashIncentiveStore } = store
    const { twoTimeCashIncentive, twoTimeCashIncentiveActive } = twoTimeCashIncentiveStore

    if (!twoTimeCashIncentiveActive) { return 0 }

    let incentiveAmount = 0
    Object.entries(twoTimeCashIncentive).forEach((incentive) => {
      const enableIncentive = incentive[1]
      if (enableIncentive) {
        const twoTimeCashIncentiveKey = incentive[0] as TwoTimeCashIncentiveKey
        const twoTimeCashIncentiveTier = TwoTimeCashIncentiveTierData[twoTimeCashIncentiveKey]
        const tier = countryData.tiers[twoTimeCashIncentiveTier[1]]![twoTimeCashIncentiveTier[0]]!
        incentiveAmount = incentiveAmount + tier
      }
    })

    return incentiveAmount
  }

}
